/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	createRecordingSession(payload) {
		return axios.post(
			`${config.SCHEDULE_BROADCASTER_URL}/api/v1/accounts/${store.getters.getOrgID()}/stations/${store.getters.liveModeSelectedStationID()}/live_sessions`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	deleteRecordingSession(session_id, afterDuration) {
		return axios.delete(
			`${config.SCHEDULE_BROADCASTER_URL}/api/v1/accounts/${store.getters.getOrgID()}/stations/${store.getters.liveModeSelectedStationID()}/live_sessions/${session_id}?after=${afterDuration}`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	resetStationEvent(params) {
		return axios.post(
			`${config.SCHEDULE_BROADCASTER_URL}/api/v1/shows/${params.showID}/events/${params.eventID}/subscribers/${params.stationID}/remove`,
			null,
			{
				params: {
					retrigger: params.retrigger ?? true,
					override_id: params.overrideID
				},
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	syncStationEvent(params) {
		return axios.post(
			`${config.SCHEDULE_BROADCASTER_URL}/api/v1/shows/${params.showID}/events/${params.eventID}/subscribers/${params.stationID}/sync`,
			null,
			{
				params: {
					override_id: params.override_id
				},
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	},

	syncShowEvent(params) {
		return axios.post(
			`${config.SCHEDULE_BROADCASTER_URL}/api/v1/shows/${params.showID}/events/${params.eventID}/sync`,
			null,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	}
}
